import { render, staticRenderFns } from "./ques11.vue?vue&type=template&id=dabb1db8&scoped=true"
import script from "./ques11.vue?vue&type=script&lang=js"
export * from "./ques11.vue?vue&type=script&lang=js"
import style0 from "./ques11.vue?vue&type=style&index=0&id=dabb1db8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabb1db8",
  null
  
)

export default component.exports